<template>
  <el-form :model="form" label-width="120px" :rules="rules" ref="formFilter">
    <el-form-item label="Árvore" prop="arvoreId">
      <el-select v-model="form.arvoreId" placeholder="Árvore" filterable>
        <el-option v-for="arvore in arvoreList" :key="arvore.id" :label="arvore.nome"
                   :value="arvore.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click.stop="handleForm">Aplicar</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "ArvoreFilter",
    props: ['filterIsVisible'],
    data() {
      return {
        form: {
          ano: null,
          mes: null,
          arvoreId: null
        },
        rules: {
          arvoreId: [
            {required: true, message: 'Por favor, selecione uma Árvore', trigger: 'blur'}
          ],
          ano: [
            {required: true, message: 'Por favor, selecione um Ano', trigger: 'blur'}
          ],
          mes: [
            {required: true, message: 'Por favor, selecione uma Mês', trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      ...mapState(['anoSelected', 'mesSelected', 'arvoreList', 'anos', 'meses']),
    },
    methods: {
      handleForm() {
        this.$refs.formFilter.validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$bus.$emit('ArvoreHandleForm', {...this.form})
        });
      }
    },
    mounted() {
      this.form.ano = this.anoSelected
      this.form.mes = this.mesSelected
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/ArvoreFilter.vue